import User from '../model/User.model';
import { normalizeEmail } from './email';
// import User from '../model/User.model';

const KEY_ACCESS_TOKEN = "access_token";
const KEY_REFRESH_TOKEN = "refresh_token";
const KEY_EMAIL = "email";
const KEY_EXPIRE_TIME = "exp";

export const storeUserLoggedData = (accessToken: string, expiration: number | undefined, user: User) => {
  setAccessToken(accessToken);
  setExpireTime(expiration);
  setEmail(user.email);
};

export const resetUserLoggedData = (): void => {
  removeRefreshToken();
  removeAccessToken();
  removeEmail();
  removeExpireTime();
};

export const isAccessTokenExpired = (): boolean => {
  const expireTime = Number(getExpireTime());
  return !expireTime || Math.round(new Date().getTime() / 1000) > expireTime;
};

export const isUserLogged = (): boolean => {
  return (
    getAccessToken() != null &&
    getEmail() != null &&
    !isAccessTokenExpired()
  );
};

export const getUserLogged = (): User|undefined => {
  return isUserLogged() ? new User(getEmail() || "","","","") : undefined
};

// ACCESS TOKEN
export const setAccessToken = (access_token: string) => {
  localStorage.setItem(KEY_ACCESS_TOKEN, access_token || "");
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(KEY_ACCESS_TOKEN);
};

const removeAccessToken = (): void => {
  localStorage.removeItem(KEY_ACCESS_TOKEN);
};

const removeRefreshToken = (): void => {
  localStorage.removeItem(KEY_REFRESH_TOKEN);
};

// EMAIL
const setEmail = (email: string) => {
  localStorage.setItem(KEY_EMAIL, email ? normalizeEmail(email) : "");
};

export const getEmail = (): string | null => {
  return localStorage.getItem(KEY_EMAIL);
};

const removeEmail = (): void => {
  localStorage.removeItem(KEY_EMAIL);
};

// EXP TIME
export const setExpireTime = (exp: string | number | undefined) => {
  localStorage.setItem(KEY_EXPIRE_TIME, String(exp || ""));
};

export const getExpireTime = (): string | null => {
  return localStorage.getItem(KEY_EXPIRE_TIME);
};

const removeExpireTime = (): void => {
  localStorage.removeItem(KEY_EXPIRE_TIME);
};
